import React from 'react';

const WalletIcon = ({ ...rest }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_147_3830)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.40307 6H2.99707C2.16907 6 1.49707 6.67125 1.49707 7.5V9H5.40307V6Z"
          fill="white"
        />
        <path
          d="M12 15C15.7279 15 18.75 11.9779 18.75 8.25C18.75 4.52208 15.7279 1.5 12 1.5C8.27208 1.5 5.25 4.52208 5.25 8.25C5.25 11.9779 8.27208 15 12 15Z"
          fill="white"
        />
        <path
          d="M12 12C14.0711 12 15.75 10.3211 15.75 8.25C15.75 6.17893 14.0711 4.5 12 4.5C9.92893 4.5 8.25 6.17893 8.25 8.25C8.25 10.3211 9.92893 12 12 12Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.4971 11.25C22.4971 10.0073 21.4898 9 20.2471 9C14.8283 9 1.49707 9 1.49707 9V20.25C1.49707 21.4928 2.50432 22.5 3.74707 22.5H20.2471C21.4898 22.5 22.4971 21.4928 22.4971 20.25C22.4971 17.7533 22.4971 13.7467 22.4971 11.25Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.4999 17.9948C20.8454 17.9948 19.5029 16.9875 19.5029 15.747C19.5029 14.5073 20.8454 13.5 22.4999 13.5V17.9948Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.12482 5.25C6.28282 2.6025 8.92732 0.75 12.0001 0.75C16.1393 0.75 19.5001 4.11075 19.5001 8.25H20.2471C21.9038 8.25 23.2471 9.59325 23.2471 11.25V20.25C23.2471 21.9067 21.9038 23.25 20.2471 23.25H3.74707C2.09032 23.25 0.74707 21.9067 0.74707 20.25C0.74707 16.41 0.74707 7.5 0.74707 7.5C0.74707 6.25725 1.75432 5.25 2.99707 5.25H5.12482ZM21.7471 12.8107V11.25C21.7471 10.4213 21.0758 9.75 20.2471 9.75H2.24707V20.25C2.24707 21.0788 2.91907 21.75 3.74707 21.75H20.2471C21.0758 21.75 21.7471 21.0788 21.7471 20.25V18.684C20.0078 18.3975 18.7531 17.142 18.7531 15.747C18.7531 14.3527 20.0078 13.0972 21.7471 12.8107ZM4.50307 20.25H5.99707C6.41107 20.25 6.74707 19.914 6.74707 19.5C6.74707 19.086 6.41107 18.75 5.99707 18.75H4.50307C4.08907 18.75 3.75307 19.086 3.75307 19.5C3.75307 19.914 4.08907 20.25 4.50307 20.25ZM4.50307 18H7.49707C7.91107 18 8.24707 17.664 8.24707 17.25C8.24707 16.836 7.91107 16.5 7.49707 16.5H4.50307C4.08907 16.5 3.75307 16.836 3.75307 17.25C3.75307 17.664 4.08907 18 4.50307 18ZM21.7471 14.3385C21.3983 14.424 21.0856 14.568 20.8313 14.7585C20.4886 15.015 20.2531 15.3562 20.2531 15.747C20.2531 16.1385 20.4886 16.479 20.8313 16.7362C21.0856 16.9268 21.3983 17.0708 21.7471 17.1555V14.3385ZM18.0001 8.25H16.5001C16.5001 5.766 14.4841 3.75 12.0001 3.75C9.51607 3.75 7.50007 5.766 7.50007 8.25H6.00007C6.00007 4.93875 8.68882 2.25 12.0001 2.25C15.3113 2.25 18.0001 4.93875 18.0001 8.25ZM15.0001 8.25H9.00007C9.00007 6.594 10.3441 5.25 12.0001 5.25C13.6561 5.25 15.0001 6.594 15.0001 8.25ZM4.65007 6.75H2.99707C2.58307 6.75 2.24707 7.086 2.24707 7.5V8.25H4.50007C4.50007 7.73625 4.55182 7.2345 4.65007 6.75Z"
          fill="#1877F2"
        />
      </g>
      <defs>
        <clipPath id="clip0_147_3830">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WalletIcon;
